import React from "react";
function NewsRow(props) {
  return (
    <React.Fragment>
      <tr id={props.id}>
        <td className="name news__row">
          <div className="heading">{props.name}</div>
          <div className="description">{props.description}{props.description}{props.description}{props.description}{props.description}</div>
        </td>
        <td className="date">{props.date}</td>
      </tr>
    </React.Fragment>
  );
}
export default NewsRow;
